module.exports = __webpack_public_path__ + "media/src/images/site-top/bg-border-114c14cc6316433235d7b5d3549fcdc8.png";